// extracted by mini-css-extract-plugin
export var explainable = "_f2-a";
export var printerCard = "_f2-1";
export var printerCardConfigured = "_f2-2";
export var printerCardError = "_f2-3";
export var printerCardsContainer = "_f2-0";
export var printerIcon = "_f2-8";
export var printerIconConfigured = "_f2-5";
export var printerIconContainer = "_f2-4";
export var printerIconError = "_f2-6";
export var printerIconUnconfigured = "_f2-7";
export var workstationsTableCard = "_f2-9";